import { ISwitchComponentProps } from '../../../common/utils/types';
import { useSelector } from 'react-redux';
import { selectFormFields } from '../../selectors';
import * as React from 'react';
import { useActions } from '../useActions';

export const useSwitchComponentProps = (): ISwitchComponentProps => {
  const { isChatSubscribeActive } = useSelector(selectFormFields);
  const { setChatSubscribeActive } = useActions();

  const onValueChange = React.useCallback<ISwitchComponentProps['onChange']>(() => {
    setChatSubscribeActive(!isChatSubscribeActive);
  }, [isChatSubscribeActive]);

  return {
    isChecked: isChatSubscribeActive,
    onChange: onValueChange,
  };
};
